export default __webpack_public_path__ + "static/media/rescale_summary_cap_table_12.6.22.fbe92630.pdf";